import {
  isStoneUnit,
  isKgUnit,
  STONE_POUNDS_LIMITS,
  KG_LIMITS,
  POUND_LIMITS
} from "../../../utils/weight";
import t from "../../../utils/translate";

const poundsLabel = t("WEIGHT_UNITS_POUNDS");
const poundsLabelShort = t("WEIGHT_UNITS_POUNDS_SHORT");
const stonesLabel = t("WEIGHT_UNITS_STONES");
const stonesLabelShort = t("WEIGHT_UNITS_STONES_SHORT");

function getStonesInputConfig() {
  return {
    label: {
      stone: {
        appended: stonesLabel,
        appendedShort: stonesLabelShort
      },
      pounds: {
        appended: poundsLabel,
        appendedShort: poundsLabelShort
      }
    },
    ...STONE_POUNDS_LIMITS
  };
}

function getKilogramsInputConfig() {
  return {
    label: {
      appended: t("WEIGHT_UNITS_KILO"),
      appendedShort: t("WEIGHT_UNITS_KILO_SHORT")
    },
    ...KG_LIMITS
  };
}

function getPoundsInputConfig() {
  return {
    label: {
      appended: poundsLabel,
      appendedShort: poundsLabelShort
    },
    ...POUND_LIMITS
  };
}

export default function useWeightInputConfig(unit) {
  switch (true) {
    case isStoneUnit(unit):
      return getStonesInputConfig();

    case isKgUnit(unit):
      return getKilogramsInputConfig();

    default:
      return getPoundsInputConfig();
  }
}
